// extracted by mini-css-extract-plugin
module.exports = {"AdSlotMail__mail":"bgg_a bhe_vf bhe_a bhe_q bhe_k","AdSlotMail__mail--notLoaded":"bgg_b bhe_eu bhe_bj bhe_vu","show-ad-not-loaded":"bgg_c","AdSlotMail__cta":"bgg_e"};